import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ListContainer, ListWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import {
    MainContent,
    ColumnOneOfTwo,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { ListHeader } from 'src/domains/layouts/shared/cms/list/listHeader/ListHeader';
import { SeoPageForm } from 'src/main/cms/SeoManagement/SeoForm/SeoForm';
import { useAppStateContext } from 'src/AppState/AppState';
import { SeoFormState, SeoPageType } from 'src/main/cms/SeoManagement/SeoForm/SeoFormState';
import { EmptyListItem } from 'src/domains/layouts/shared/cms/list/listItems/EmptyListItem';
import { SeoListItem } from 'src/main/cms/SeoManagement/SeoListItem';
import { useCommon } from 'src/AppState/Common';

interface SeoPagesPropsType {
    seoFormState: SeoFormState;
}

const SeoPages = observer(({ seoFormState }: SeoPagesPropsType) => {
    const { isLoading, seoPagesData } = seoFormState;

    return (
        <TwoColumnResponsiveContentReverse>
            <ColumnOneOfTwo>
                <ListWrapper>
                    <ListHeader label='Seo Pages'>
                        Here you can set the seo descriptions for homepage, casino and sports pages. The content will be
                        visible on the bottom of the page.
                    </ListHeader>
                    <ListContainer
                        data-test='seo-pages-list-container'
                        areLoading={isLoading}
                    >
                        <Loader isActive={isLoading} />

                        {seoPagesData.length === 0 ? (
                            <EmptyListItem />
                        ) : (
                            <>
                                {seoPagesData.map((seoPageItem: SeoPageType) => {
                                    return (
                                        <SeoListItem
                                            key={seoPageItem.id}
                                            seoPageType={seoPageItem}
                                            seoFormState={seoFormState}
                                        />
                                    );
                                })}
                            </>
                        )}
                    </ListContainer>
                </ListWrapper>
            </ColumnOneOfTwo>

            <ColumnOneOfTwo>
                <SeoPageForm
                    dataTest='seo-pages-form'
                    seoFormState={seoFormState}
                />
            </ColumnOneOfTwo>
        </TwoColumnResponsiveContentReverse>
    );
});

export const SeoPagesComponent = observer(() => {
    const { sdkStaff, cmsState } = useAppStateContext();
    const common = useCommon();
    const [seoFormState] = useState(
        () => new SeoFormState(sdkStaff, cmsState.cmsTranslations, cmsState.languagesState, common)
    );

    const key = `${seoFormState.cmsTranslationsSeoPagesList.length}--${seoFormState.isEditMode ? 'editMode' : 'newMode'}`;

    return (
        <MainContent data-test='seo-pages'>
            <SeoPages
                key={key}
                seoFormState={seoFormState}
            />
        </MainContent>
    );
});
